import React, { forwardRef } from 'react';
import ReactDOM from 'react-dom';
import DraggableModalWrapper from 'chameleon/packages/blue-book-player/library/modal/DraggableModal/DraggableModalWrapper';

const DraggableModal = forwardRef((props, ref) => {
  const {
    title,
    children,
    onClose,
    defaultPosition,
    defaultWidth,
    contentWithSpacing,
    contentClassName,
    isScrollableContent,
    size,
    wrapperClassName,
    dialogClassName,
    draggableClassName,
    wrapperStyles,
    expandedWidth,
    collapsedWidth,
    onToggleSize,
    defaultResetTo,
    accessibilityDragButton,
    accessibilityCloseButton,
    accessibilityResizeButton,
    onDragStart,
    focuslockDisabled,
  } = props;

  return ReactDOM.createPortal(
    <DraggableModalWrapper
      title={title}
      defaultPosition={defaultPosition}
      defaultWidth={defaultWidth}
      onClose={onClose}
      ref={ref}
      contentWithSpacing={contentWithSpacing}
      isScrollableContent={isScrollableContent}
      contentClassName={contentClassName}
      size={size}
      wrapperClassName={wrapperClassName}
      dialogClassName={dialogClassName}
      draggableClassName={draggableClassName}
      wrapperStyles={wrapperStyles}
      expandedWidth={expandedWidth}
      collapsedWidth={collapsedWidth}
      onToggleSize={onToggleSize}
      defaultResetTo={defaultResetTo}
      accessibilityDragButton={accessibilityDragButton}
      accessibilityCloseButton={accessibilityCloseButton}
      accessibilityResizeButton={accessibilityResizeButton}
      onDragStart={onDragStart}
      focuslockDisabled={focuslockDisabled}
    >
      {children}
    </DraggableModalWrapper>,
    document.querySelector('#modal'),
  );
});

export default DraggableModal;
